import { appData } from '@/mocks/home';

export default function AppSection() {
  const item = appData[0];

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
              移动畅读
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              {item.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {item.description}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {item.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 text-xs font-medium bg-background-50 text-foreground-700 rounded-full border border-background-200"
                >
                  {f}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 bg-background-50 rounded-2xl flex items-center justify-center border border-background-200">
              <div className="text-center">
                <i className="ri-qr-code-line text-5xl md:text-6xl text-foreground-700 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto" />
                <p className="mt-2 text-xs text-foreground-500">{item.qrLabel}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}